import React, { useState, useEffect } from "react";
// styles
import "./styles.scss";
// images and Svg
import pdfimage from "../../../assets/images/PdfImg.svg";
import Jpgimage from "../../../assets/images/JpgImg.svg";
import eyeIcon from "../../../assets/images/eyeIcon.svg";
import Mailimage from "../../../assets/images/Pdfmail.svg";
import excelImage from "../../../assets/icons/excelIcon.svg";
import downloadIcon from "../../../assets/icons/downloadIcon.svg";
import { Toast } from "service/toast";

const DocumentsViewComponents = ({
  jpg = false,
  fileName = "",
  fileSize = "",
  pdf = false,
  download = false,
  mail = false,
  isDocument,
  handleView,
  excel = false,
  multipleIcon = false,
  isDownload,
  dontOpenPdf = false,
}) => {
  const [shouldDownload, setShouldDownload] = useState(false);

  const handleDownload = () => {
    setShouldDownload(true);
  };
  const handleViewPDF = () => {
    if (dontOpenPdf) {
      return;
    } else if (pdf) {
      const url = pdf;
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    }else{
      Toast({type : "error", message: "File not Found"})
    }
  };

  const handleImage = (fileName) => {
    if (fileName?.includes("pdf")) {
      return <img src={pdfimage} alt="" />;
    } else if (fileName?.includes("xlsx")) {
      return <img src={excelImage} alt="" />;
    } else {
      return <img src={Jpgimage} alt="" />;
    }
  };
  
  const fileSizeConvertor = (type, size) => {
    switch (type) {
      case "MB_TO_KB":
        var sizeInKB = size * (1024 * 1024);
        return sizeInKB;
      case "TO_MB":
        var sizeInMB = (size / (1024 * 1024)).toFixed(2);
        return sizeInMB + "MB";
      default:
        return size;
    }
  };

  return (
    <div className="dc-view cursor-pointer col-12 col-md-auto" onClick={handleView}>
      <div
        className={`
        ${
          download && !isDocument
            ? "conatiner1"
            : download && isDocument
            ? "conatiner-doc"
            : isDownload
            ? "conatiner1"
            : "conatiner"
        }`}
      >
        {pdf && <img src={pdfimage} alt="" />}
        {jpg && <img src={Jpgimage} alt="" />}
        {excel && <img src={excelImage} alt="" />}
        {multipleIcon && handleImage(fileName)}
        <p className="fileName text-start mb-0 ps-3 w-md-50 w-100">{window?.innerWidth <= 768 ? fileName?.length > 28 ? fileName?.slice(0,27) + "..." : fileName : fileName}</p>
        {fileSize && (
          <span className="fileSize">
            {fileSizeConvertor("TO_MB", fileSize)}
          </span>
        )}
        <div className="download_side">
          {download && <img src={eyeIcon} onClick={handleViewPDF} />}
          {isDownload && (
            <img src={downloadIcon} alt="" onClick={handleDownload} />
          )}
          {mail && <img src={Mailimage} />}
        </div>
      </div>
    </div>
  );
};

export default DocumentsViewComponents;
